import React, { PropTypes, Component } from 'react';
import { NitroHeading, NitroParagraph } from 'nitro-components';

import * as MaterialStepper from 'material-ui/Stepper';
const { Stepper, Step, StepLabel } = MaterialStepper;

import styled from 'styled-components';

const Title = styled(NitroHeading)`
  margin-top: 10px;
  color: ${props => props.active && props.theme.color.secondary};
`;

const StepComponent = styled(Step)`
  width: 33.3%;

  .step-label {
    flex-direction: column;
    height: auto !important;
    padding: 0 !important;
    text-align: center;

    span{
      &:after {
        content: "";
        display: block;
        position: absolute;
        height: 2px;
        width: 85%;
        background: ${props => props.theme.color.border};
        top: 50%;
        left: 100%;
        transform: translate(-50%, -50%);
      }
    }

    svg {
      margin: 0 auto;
      width: 12px !important;
      height: 12px !important;
      text {
        display: none !important;
      }
      circle {
        fill: ${props => (props.active ? props.theme.color.secondary : props.theme.color.white)};
        stroke: ${props => (props.active ? 'none' : props.theme.color.border)};
        stroke-width: 3px;


      }
    }
  }

  &:last-child {
    .step-label {
      span{
        &:after {
          display: none;
        }
      }

      ${props => props.active && `
        svg{
          fill: ${props => props.theme.color.primary};
          stroke: none;
        }
      `}
    }
  }


`;

class Steps extends Component {
  render() {
    const { steps } = this.props;

    return (
      <Stepper style={{ alignItems: 'flex-start' }} connector={null}>
        {steps.map((step, idx) => {
          const active = step['@Selected'] === 'true';

          return (
            <StepComponent key={idx} active={active}>
              <StepLabel
                className="step-label"
                iconContainerStyle={{ position: 'relative', padding: 0, width: '100%' }}>
                <Title label={step.Header} size="4" variant="base3" active={active} noMargin />
                <NitroParagraph size="4" variant="base3" noMargin align="center">{step.SubHeader}</NitroParagraph>
              </StepLabel>
            </StepComponent>
          );
        })}
      </Stepper>
    );
  }
}

Steps.propTypes = {
  steps: PropTypes.array
};

export default Steps;



// WEBPACK FOOTER //
// ./src/components/factoryComponents/Steps.js